import { FC } from 'react'

import { FF, FormType, RadioGroup, TextareaInput } from 'ui/components'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'

import { QuestionnaireDemo } from '../../../../../../types'
import * as SC from '../../../../style'

export const DepositLog: FC<{ formApi: FormType<QuestionnaireDemo> }> = ({ formApi }) => {
  return (
    <>
      <FormRow>
        <Col>
          <SC.SecondText>Deposits by third parties with no apparent connection to the accountholder.</SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="thirdPartyDepositsUnconnected"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>
            Individuals conducting frequent cash deposits are added to our customer's CIF profile as an authorized
            conductor on the account. Front line Staff/Bankers will notify BSA Personnel if a conductor has no apparent
            connection to the accountholder.
          </SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="cashConductorsAuthorized"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>
            Review Deposit Log for name and occupation for person conducting the deposit transaction.
          </SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="depositLogReview"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col2x>
          <formApi.Field
            name="depositLogComments"
            children={(field) => (
              <FF field={field} label="Comments" input={(p) => <TextareaInput maxLength={5000} {...p} />} />
            )}
          />
        </Col2x>
      </FormRow>
    </>
  )
}
